const SearchInput = {
  handleInput(event) {
    const value = event.target.value.trim();
    const button = event.target.parentNode.querySelector('[data-selector="search.button"]');

    if (value.length > 0) {
      button?.classList.add('is-clear');
    } else {
      button?.classList.remove('is-clear');
    }
  },

  handleClear(event) {
    const button = event.currentTarget; 
    const container = button.closest('[data-selector="search.container"]'); 
    const input = container.querySelector('[data-selector="search.input"]');
    input.value = ''; 
    button.classList.remove('is-clear'); 
    input.focus(); 
  },

  bindEvents(container) {
    const input = container.querySelector('[data-selector="search.input"]');
    const button = container.querySelector('[data-selector="search.button"]');

    input?.addEventListener('input', this.handleInput.bind(this));
    button?.addEventListener('click', this.handleClear.bind(this));
  },

  init() {
    const searchContainers = document.querySelectorAll('[data-selector="search.container"]');
    if (!searchContainers.length) return;

    searchContainers.forEach((container) => {
      this.bindEvents(container);
    });
  },
};

export default SearchInput;